module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.communityNameService.widget":[{"value":"Admin_CommunityService","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/root/communityNameService.opt
// module id = 218
// module chunks = 2